<template>
    <div class="quiz-game-home">
        <div class="title">{{ $t('HTwbActKitHome.title') }}</div>
        <div class="game-menu">
            <div class="game-row">
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-molegame-play')" :src="require('@/assets/HTwbActAssets/home/cover-molegame.webp')" alt="Mole Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.moleGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('moleGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pvpgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-pvpgame.webp')" alt="PVP Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.pvpGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('pvpGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pvp-tfgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-tfgame.webp')" alt="TF Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.tfGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('tfGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
            </div>
            <div class="game-row">
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-pickgame-play')" :src="require('@/assets/HTwbActAssets/home/cover-pick.webp')" alt="Pick Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.pickGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('pickGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
                <div class="game-item">
                    <div class="game-card" >
                        <img @click="navigateToGame('/ht-punchboard-play')" :src="require('@/assets/HTwbActAssets/home/cover-punchboard.webp')" alt="PunchBoard Game">
                        <div class="game-name">{{ $t('HTwbActKitHome.punchBoardGame') }}</div>
                    </div>
                    <div class="info-icon" @click.stop="showGameInfo('punchBoardGame')">
                        <svg-icon icon-class="info" />
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 遊戲說明彈出視窗 -->
        <div class="popup-overlay" v-if="showPopup" @click="closePopup"></div>
        <div class="game-info-popup" v-if="showPopup">
            <div class="popup-header">
                <h2>{{ $t(`HTwbActKitHome.${currentGame}Title`) }}</h2>
                <div class="close-btn" @click="closePopup">
                    <svg-icon icon-class="close" />
                </div>
            </div>
            <div class="popup-content">
                <div class="game-image">
                    <img :src="require(`@/assets/HTwbActAssets/home/cover-${currentGameKey}.webp`)" :alt="$t(`HTwbActKitHome.${currentGame}Title`)">
                </div>
                <div class="game-description">
                    <p>{{ $t(`HTwbActKitHome.${currentGame}Desc`) }}</p>
                </div>
                <div class="popup-footer">
                    <button class="play-btn" @click="playCurrentGame">{{ $t('HTwbActKitHome.play') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import SvgIcon from '@/components/SvgIcon.vue';

const router = useRouter();

// 狀態變數
const showPopup = ref(false);
const currentGame = ref('');
const currentGameKey = ref('');
const gameRoutes = {
    pvpGame: '/ht-pvpgame-play',
    moleGame: '/ht-molegame-play',
    tfGame: '/ht-pvp-tfgame-play',
    pickGame: '/ht-pickgame-play',
    punchBoardGame: '/ht-punchboard-play'
};

// 方法
const navigateToGame = (route) => {
    router.push(route);
};

const showGameInfo = (gameType) => {
    currentGame.value = gameType;
    currentGameKey.value = gameType === 'pvpGame' ? 'pvpgame' : 
                       gameType === 'moleGame' ? 'molegame' : 
                       gameType === 'tfGame' ? 'tfgame' :
                       gameType === 'pickGame' ? 'pick' : 'punchboard';
    showPopup.value = true;
};

const closePopup = () => {
    showPopup.value = false;
};

const playCurrentGame = () => {
    if (currentGame.value && gameRoutes[currentGame.value]) {
        navigateToGame(gameRoutes[currentGame.value]);
        closePopup();
    }
};

// 通信工具類
const MessageBridge = {
    // 環境類型
    ENV: {
        WEBVIEW: 'webview',
        WEB: 'web'
    },
    // 當前環境
    currentEnv: 'webview',
    // 初始化
    init() {
        this.currentEnv = window?.chrome?.webview ? this.ENV.WEBVIEW : this.ENV.WEB;
        return this;
    },
    // 發送消息
    postMessage(data, origin = '*') {
        if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.postMessage(data);
        } else {
            window.postMessage(data, origin);
        }
    },
    // 添加消息監聽器
    addEventListener(callback) {
        if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.addEventListener('message', event => {
                callback(event);
            });
        } else {
            window.addEventListener('message', event => {
                callback(event);
            });
        }
    }
};

// 初始化消息橋接器
const messageBridge = MessageBridge.init();

onMounted(() => {
    // messageBridge.postMessage({ action: 'GoTo.Game', data: { page: 'molegame' } });
    // 添加消息監聽器
    messageBridge.addEventListener(event => {
        const msg = event.data;
        if (msg.action === 'GoTo.Game') {
            console.log(msg, 'GoTo.Game')
            switch(msg?.data?.page) {
                case 'pvpgame':
                    navigateToGame('/ht-pvpgame-play');
                    break;
                case 'molegame':
                    navigateToGame('/ht-molegame-play');
                    break;
                case 'tfgame':
                    navigateToGame('/ht-pvp-tfgame-play');
                    break;
                case 'pickgame':
                    navigateToGame('/ht-pickgame-play');
                    break;
                case 'punchboard':
                    navigateToGame('/ht-punchboard-play');
                    break;    
                default:
                    break;
            }
        }
    });
});
</script>

<style lang="less" scoped>
.quiz-game-home {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
    position: relative;

    .title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 30px;
        color: #333;
        text-align: center;
    }

    .game-menu {
        width: 100%;
        max-width: 1200px;

        .game-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 30px;
            margin-bottom: 30px;
        }

        .game-item {
            position: relative;
            width: 300px;
            transition: transform 0.3s ease;

            &:hover {
                transform: translateY(-5px);
            }

            .game-card {
                cursor: pointer;
                background-color: white;
                border-radius: 15px;
                overflow: hidden;
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;

                &:hover {
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
                }

                img {
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    object-position: center;
                }

                .game-name {
                    padding: 15px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    color: #333;
                }
            }

            .info-icon {
                position: absolute;
                bottom: 15px;
                left: 15px;
               
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              
                z-index: 2;
                transition: all 0.2s ease;

                &:hover {
                    transform: scale(1.1);
                    background-color: #fff;
                }

                svg {
                    width: 30px;
                    height: 30px;
                    color: gray;
                }
            }
        }
    }

    // 彈出視窗樣式
    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 100;
    }

    .game-info-popup {
        position: fixed;
        top: 10vh;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        max-width: 500px;
        background-color: white;
        border-radius: 15px;
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
        z-index: 101;
        overflow: hidden;

        .popup-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding:0px 20px;
            font-weight: bold;
            border-bottom: 1px solid #eee;

            h2 {
                margin: 0;
                font-size: 20px;
                color: #333;
            }

            .close-btn {
                cursor: pointer;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all 0.2s ease;
                font-size: 24px;

                svg {
                    font-size: 24px;
                    line-height: 1;
                    color: #555;
                }
                &:hover {
                    svg {
                        font-size: 26px;
                    }
                }
            }
        }

        .popup-content {
            padding: 20px;

            .game-image {
                width: 100%;
                max-height: 300px;
                overflow: hidden;
                margin-bottom: 20px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: auto;

                border-radius: 10px;
                    max-width: 100%;
                    height: auto;
                    max-height: 300px;
                    object-fit: contain;
                }
            }

            .game-description {
                margin-bottom: 20px;

                p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                    white-space: pre-line;
                }
            }

            .popup-footer {
                display: flex;
                justify-content: center;

                .play-btn {
                    padding: 10px 30px;
                    background-color: #4CAF50;
                    color: white;
                    border: none;
                    border-radius: 30px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: #45a049;
                        transform: translateY(-2px);
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .quiz-game-home {
        .game-menu {
            .game-item {
                width: 100%;
                max-width: 300px;
            }
        }

        .game-info-popup {
            width: 95%;
            max-height: 90vh;
            overflow-y: auto;
        }
    }
}
</style>